import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AnkietaContextProvider } from './Context/PollSystem';
import { KioskConfigContextProvider } from './Context/KioskConfigContext';
import AnkietaPage from './pages/AnkietaPage';
import AppPage from './pages/AppPage';
import ConfigurePage from './pages/ConfigurePage';
import InstallPage from './pages/InstallPage';
import MainPage from './pages/MainPage';
import NotFoundPage from './pages/NotFoundPage';
import RegisterPage from './pages/RegisterPage';
import TestingSandbox from './pages/TestingSandbox';
import ClientPreview from './pages/ClientPreview';

const App = () => (
  <KioskConfigContextProvider>
    <AnkietaContextProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<MainPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/configure" element={<ConfigurePage />} />
          <Route path="/install" element={<InstallPage />} />
          <Route path="/app" element={<AppPage />} />
          <Route path="/poll" element={<AnkietaPage />} />

          <Route path="/test" element={<TestingSandbox />} />

          <Route path="/client_preview" element={<ClientPreview />} />
          {/* NotFound */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </BrowserRouter>
    </AnkietaContextProvider>
  </KioskConfigContextProvider>
);

export default App;
